import type { FC } from 'react';
import type { FormikProps } from 'formik';
import type { FormSchema } from '../schema/types';
import { renderSections } from './renderSection';

export type RenderFormProps = {
  schema: FormSchema;
  form: FormikProps<any>;
  isSubmitted: boolean;
  t: (key: string) => string;
  dynamicOptions?: Record<string, Array<{ value: unknown; label: string }>>;
  disabled?: boolean;
};

export const RenderForm: FC<RenderFormProps> = ({
  schema,
  form,
  isSubmitted,
  t,
  dynamicOptions,
  disabled,
}) => (
  <>
    {renderSections(schema.sections, {
      form,
      isSubmitted,
      t,
      dynamicOptions,
      disabled,
    })}
  </>
);

export default RenderForm;
